module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon-check.83e4cf0d.svg";